'use strict'

const $ = window.jQuery;

export default function () {
    $('#toggleSharer').on('click', function () {
        $(this).parent().toggleClass('is-active');
        $('#socialSharer').slideToggle();
    });
};
